import React, { useState } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { MinusIcon, PlusIcon } from '~svg';

import './index.scss';
import { Accordion } from '../../common';
function FAQDetails({ containerClass }) {
  let QuestionAnswer = [
    {
      Question: 'faq.firstquestion',
      Answer: 'faq.secendanswer',
      id: 1,
      class: 'First',
      selected: false,
    },
    {
      Question: 'faq.secendquestion',
      Answer: 'faq.firstanswer',
      id: 2,
      class: 'secend',
      selected: false,
    },
    {
      Question: 'faq.thirdquestion',
      Answer: 'faq.thirdanswer',
      id: 3,
      class: 'third',
      selected: false,
    },
  ];

  let [Question, setQuestion] = useState(QuestionAnswer);
  const changeAccordionStatus = (id) => {
    let newList = [...Question];
    newList.map((item, index) => {
      if (item.id === id) {
        let pStatus = newList.filter((item) => item.id === id)[0].selected;
        newList.filter((item) => item.id === id)[0].selected = !pStatus;
      } else newList[index].selected = false;
    });
    setQuestion(newList);
  };

  return (
    <div
      className={`p-4 w-100 d-flex flex-column rounded-2 bg-white ${containerClass}`}
    >
      <div className="d-flex text-primary font-weight-bold font-xlarge">
        <FormattedMessage id="faq.faq" />
      </div>
      {Question.map((item, key) => {
        return (
          <Accordion
            key={`question-${key}`}
            id="firstQuestion"
            classTitle="font-weight-bolder font-normal"
            classContainer={'mt-3'}
            title={<FormattedMessage id={item.Question} />}
            classChildren={'p-sm-3 px-1 py-2'}
          >
            <div className="card-body bg-white d-flex py-2 px-sm-3 px-0 text-start  font-small font-weight-light">
              <FormattedMessage id={item.Answer} />
            </div>
          </Accordion>
        );
      })}
      {/* <div className="" id="accordion">
        {Question.map((item, key) => {
          return (
            <div
              className=" card bg-white d-flex flex-column rounded border border-0 "
              key={key}
            >
              <div
                className="card-header p-0 selected d-flex justify-content-between align-items-center w-100 cursor-pointer"
                id={`${item.class}`}
                onClick={() => {
                  changeAccordionStatus(item.id);
                }}
                style={{
                  color: Question.filter((q) => q.id === item.id)[0].selected
                    ? '#3d4a8f'
                    : '',
                }}
                data-toggle="collapse"
                data-target={`#collapse${item.id}`}
                aria-expanded="true"
                aria-controls={`collapse${item.id}`}
              >
                <span className="card-link p-2 d-flex text-start w-100 font-small font-md-normall  ">
                  <FormattedMessage id={item.Question} />
                </span>
                {Question.filter((q) => q.id === item.id)[0].selected ? (
                  <MinusIcon
                    size={14}
                    color={
                      Question.filter((q) => q.id === item.id)[0].selected
                        ? '#3d4a8f'
                        : 'black'
                    }
                  />
                ) : (
                  <PlusIcon
                    size={14}
                    color={
                      Question.filter((q) => q.id === item.id)[0].selected
                        ? '#3d4a8f'
                        : 'black'
                    }
                  />
                )}
              </div>

              <div
                id={`collapse${item.id}`}
                className="collapse"
                aria-labelledby="headingOne"
                data-parent="#accordion"
              >
                <div className="card-body bg-white d-flex py-2 px-3 text-start  font-small font-weight-light">
                  <FormattedMessage id={item.Answer} />
                </div>
              </div>
            </div>
          );
        })}
      </div> */}
    </div>
  );
}
FAQDetails.defaultProps = {
  containerClass: 'default-border-radius-small shadow',
};
export default injectIntl(FAQDetails);
